import React from "react";
// import { useSelector, useDispatch } from "react-redux";
import { Header, Sidebar } from "../Layout";
import { PieChart, Pie, ResponsiveContainer, Cell } from 'recharts';
import  AverageProjectValue  from './AverageProjectValue';
import FeedbackSnapshot from "./FeedbackSnapshot";
import ProjectPipeline from "./ProjectPipeline";
const PartnerDashboard = () => {
    const data = [
        { name: 'Partner 1', value: 400 },
        { name: 'Partner 2', value: 700 },
        { name: 'Partner 3', value: 200 },
        { name: 'Partner 4', value: 800 }
    ];
    const COLORS = ['#fa7a13', '#ff6361', '#ffa600', '#bc5090'];
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({
        cx, cy, midAngle, innerRadius, outerRadius, percent, index, nameKey
    }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${data[index]?.name} ${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };
    return (<>
        <Header />
        <Sidebar />
        <div id="main-content">
            <div className="block-header">
                <div className="row clearfix">
                    <div className="col-md-6 col-sm-12">
                        <h2>Dashboard</h2>
                    </div>
                    <div className="col-md-6 col-sm-12 text-right">
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html"><i className="icon-home"></i></a></li>
                            <li className="breadcrumb-item active">Dashboard</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <h3>Total Partner Dashboard</h3>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                        <div className="row clearfix">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <div className="card card-radius">
                                    <div className="header card-header custum-bg-warning rounded">
                                        <h2 className="text-white">Live Projects</h2>
                                    </div>
                                    <div className="body card-body-shadow">
                                        <div className="row">
                                            <div className="col-lg-12 col-md-6 col-sm-12 text-center">
                                                <ResponsiveContainer width="100%" height={600}>
                                                    <PieChart width={650} height={500}>
                                                        <Pie data={data}
                                                            dataKey="value"
                                                            nameKey="name"
                                                            stroke=""
                                                            fill="#8884d8"
                                                            label={renderCustomizedLabel}
                                                            labelLine={false}
                                                        >
                                                            {
                                                                data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                                                            }
                                                        </Pie>
                                                    </PieChart>
                                                </ResponsiveContainer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                        <AverageProjectValue />
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                    <ProjectPipeline/>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                        <FeedbackSnapshot />
                    </div>
                </div>
            </div>
            


        </div>

    </>)
}

export default PartnerDashboard;